import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { map, retry, shareReplay } from 'rxjs/operators';
import { AuthHttp } from '../../../services/http/http.service';
import { Observable } from 'rxjs';

@Injectable()
export class EmpresaService {
  private _series: Observable<any>;
  private _seriesEmpresaId: number;

  constructor(private readonly http: HttpClient, private readonly authHttp: AuthHttp) {}

  obtenerTodas() {
    return this.http.get(`${environment.apiURLs.private}/arbol`).pipe(
      map((objects: any) => {
        const output = [];
        for (const o of objects) {
          output.push({
            id: o.id,
            razon_social: o.razon_social
          });
        }
        return output;
      })
    );
  }

  set(grupo_id, empresa_id, sucursal) {
    const key = EmpresaService.name + '' + grupo_id + '' + empresa_id;
    localStorage.setItem(key, JSON.stringify(sucursal));
  }

  get(grupo_id, empresa_id) {
    const key = EmpresaService.name + '' + grupo_id + '' + empresa_id;
    return JSON.parse(localStorage.getItem(key));
  }

  getSeries(empresa_id) {
    if (!this._series || this._seriesEmpresaId !== empresa_id) {
      this._seriesEmpresaId = empresa_id;
      this._series = this.authHttp.get(`${environment.apiURLs.private}/empresa/${empresa_id}/serie/listar`).pipe(
        retry(2),
        shareReplay({ bufferSize: Infinity, refCount: true })
      );
    }
    return this._series;
  }

  usaMultifiscalidad(empresa_id: number): Observable<{ usaMultifiscalidad: boolean }> {
    return this.authHttp.get(`${environment.apiURLs.private}/empresa/${empresa_id}/usa-multifiscalidad`);
  }
}
